export const POS_ENTRY_MODE_GET ="/PosEntryModeDef/GetAllPosEntryModeDef"
export const POS_ENTRY_MODE_UPDATE = "/PosEntryModeDef/UpdatePosEntryModeDef"